import BannerRepository from "../BannerRepository"

export default class FeatureInPageBanner extends BannerRepository {
    static schemaId = "feature_banner"

    constructor() {
        super(FeatureInPageBanner.schemaId)
    }
}
